import script from "./chat-thread.vue?vue&type=script&setup=true&lang=js"
export * from "./chat-thread.vue?vue&type=script&setup=true&lang=js"

import "./chat-thread.vue?vue&type=style&index=0&id=6719ad3a&lang=css"

const __exports__ = script;

export default __exports__